<script lang="ts">
    import ReviewsTheme from "@apps/reviews/components/ReviewsTheme/ReviewsTheme.svelte";
    import { REVIEW_TYPE } from "@apps/reviews/constants";
    import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
    import { reviewsFormModalToken } from "@apps/reviews/tokens";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import { ModalManager } from "@components/Modal/ModalManager";

    import { LEAVE_REVIEW_SOURCE } from "../review_form_modal_widget/constants";

    export let reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    export let modalManager: ModalManager;

    const settings$ = reviewsStorefrontValuesService.selectReviewsSettings();
    const reviewsBranding$ =
        reviewsStorefrontValuesService.selectReviewsBrandingOptions();

    const locationContoller =
        container.resolve(CommonModule).exports.locationController;
    const searchParams = locationContoller.getSearchParams();

    const reviewRequestToken = searchParams.get("reviewRequestToken");
    const productId = searchParams.get("product_id");
    const orderId = searchParams.get("order_id");

    const reviewType = productId
        ? REVIEW_TYPE.PRODUCT_REVIEW
        : REVIEW_TYPE.SITE_REVIEW;

    onMount(() => {
        const subscription = settings$.subscribe((settings) => {
            if (settings) {
                modalManager.openModal(reviewsFormModalToken, undefined, {
                    productId: productId ? Number(productId) : undefined,
                    source: LEAVE_REVIEW_SOURCE.LEAVE_REVIEW_PAGE_WIDGET,
                    reviewType,
                    reviewRequestToken: reviewRequestToken || undefined,
                    orderId: orderId ? Number(orderId) : undefined,
                });
            }
        });

        return () => subscription.unsubscribe();
    });
</script>

{#if $reviewsBranding$}
    <ReviewsTheme branding={$reviewsBranding$}>
        {#if $settings$}
            <div class="gw-leave-review-page__container" />
        {/if}
    </ReviewsTheme>
{/if}

<style lang="postcss" global>
    @import "../../../../themes/default/default.css";
    @import "../../../../themes/globals.css";

    .gw-leave-review-page {
        &__container {
        }
    }
</style>
